import React, { useState } from "react";
import TeamAvatar from "../Assets/TeamAvatar.png";

const avatars = [
  { name: "Team 1", imageUrl: TeamAvatar },
  { name: "Team 2", imageUrl: TeamAvatar },
  { name: "Team 3", imageUrl: TeamAvatar },
  // Add more avatars as needed
];

const TeamDropdown = (props) => {
  const [open, setOpen] = React.useState(false);
  const [selectedAvatar, setSelectedAvatar] = useState(avatars[0]);

  return (
    <div className="relative">
      {/* Dropdown button */}
      <button
        style={{ width: props.width }}
        className="flex items-center px-2 py-1 border h-[41px] text-[14px] border-gray-300 rounded-md focus:outline-none"
        onClick={() => setOpen(!open)}
        onBlur={() => setOpen(false)}
      >
        <img
          className="w-[1.5rem] h-[1.5rem] mr-2"
          src={selectedAvatar.imageUrl}
          alt={selectedAvatar.name}
        />
        <span>Choose a Team to Add More Members</span>
      </button>

      {/* Dropdown list */}
      {open && (
        <ul className="absolute z-10 top-10 right-0 w-full py-2 bg-white border border-gray-300 rounded-md shadow-lg mt-2">
          {avatars.map((avatar, index) => (
            <li
              key={index}
              className="flex items-center px-4 py-2 cursor-pointer text-[14px] hover:bg-[#F9FAFB]"
              onClick={() => setSelectedAvatar(avatar)}
            >
              <img
                className="w-8 h-8 mr-2 rounded-full"
                src={avatar.imageUrl}
                alt={avatar.name}
              />
              <span>{avatar.name}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default TeamDropdown;
